/*
 * File: d:\projects\AutoFiFront\src\Content\Car\CarElement\CarElement3.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday February 9th 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Thursday, 26th September 2024 02:24:43
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { useEffect, useState, MouseEvent } from "react";
import CarCost from "Content/Car/CarCost/CarCost";
import CarInfo from "Content/Car/CarInfo/CarInfo";
import { Link, useLoaderData } from "react-router-dom";
import CarSingleCarousel from "Content/Car/CarSingleCarousel/CarSingleCarousel";
import styles from "Content/Car/CarElement/CarElement.module.css";
import CarCardHeader from "Content/Car/CarCardHeader/CarCardHeader";
import CarEquipment from "Content/Car/CarEquipment/CarEquipment";
import translator from "MultiLanguage/TranslationWrapper";
import { BsFillTelephoneInboundFill as Phone } from "react-icons/bs";
import ModalCta from "Content/Modals/ModalCta/ModalCta";
import ButtonAlt from "Theme/Component/ButtonAlt";
import HrStyled from "Theme/Component/HrStyled";
import HolderStyled from "Theme/Component/HolderStyled";
import { useMyContext } from "Content/Main/Main";
import CarService from "Services/Cars/CarService";
import { SingleCarFormat } from "Content/Car/CarElement/CarElement.type";
import ModalMakeReservation from "Content/Modals/ModalMakeReservation/ModalMakeReservation";
import OfferService from "Services/Offer/OfferService";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import Config from "Config/Config";
import { useAuth } from "Router/AuthProvider";
import { useInteractiveHeader } from "Router/HeaderInteractionProvider";

function CarElement(_: any) {
    const singleCar: SingleCarFormat = useLoaderData() as SingleCarFormat;
    const [carImg, setCarImg] = useState([]);
    const [carEquipment, setCarEquipment] = useState([]);
    const [modalCta, setModalCta] = useState(false);
    const [modalConfirm, setModalConfirm] = useState(false);
    const [isOkay, setIsOkay] = useState(false);
    const [modalReservation, setModalReservation] = useState(false);
    const themeColor: string = singleCar.iconSubSection.IconSubSection;
    const infoRequest= `mailto:${Config.COMMON.CONTACTEMAIL}?subject=${translator.decode("contact.subject").replaceAll("%i", singleCar.carInfo.Brand.toUpperCase())}&body=${translator.decode("contact.body").replaceAll("%i", singleCar.carInfo.Brand.toUpperCase()).replaceAll("%a", window.location)}`;
    const { setterThemeColor } = useMyContext();
    const { isConnected } = useAuth();
    const { setOfferCount } = useInteractiveHeader();

    useEffect(()=>{
        setterThemeColor(themeColor);
    }, []);

    const handleToggleCtaModal = (e: MouseEvent<HTMLElement>) => {
        setModalCta(false);
    };
    const handleToggleReservationModal = (e: MouseEvent<HTMLElement>) => {
        setModalReservation(false);
    };
    const handleToggleModalConfirm = (e: MouseEvent<HTMLElement>) => {
        setModalConfirm(false);
    };

    const handleMakeReservation = () => {
        OfferService.makeReservation(singleCar.id).then(() => {
            setIsOkay(true);
            setModalConfirm(true);
            setModalReservation(false);
            setOfferCount(true);
        }).catch(() => {
            setIsOkay(false);
            setModalConfirm(true);
            setModalReservation(false);
        });
    };

    useEffect(() => {
        CarService.getPicturesForOneCar(singleCar.id).then((val: {data: []}) => setCarImg(val.data)).catch((error) => console.error(error));
        CarService.getEquipementsForOneCar(singleCar.id).then((val: {data: []}) => {setCarEquipment(val.data)}).catch((error) => console.error(error));
    }, []);

    return (
        <div className={`${styles.carElementContainer}`}>
            <div className={`${styles.btnPosPhone}`}>
                {
                    singleCar.carInfo.Status.toLowerCase() !== "sold" ?
                    <Link to={infoRequest} className={`${styles.link}`}>
                        <ButtonAlt bgColor={themeColor} >
                            <Phone size={"2rem"}/>
                        </ButtonAlt>
                    </Link>
                    : null
                }
            </div>
            <div className={`${styles.widthCarou}`}>
                <HolderStyled bgColor={themeColor} className={`${styles.carElementContainerLeft}`}>
                    <div className={`${styles.carouselContainer}`}>
                        {
                            singleCar.carInfo.Status.toLowerCase() == "sold" ? <div className={`${styles.sold}`}> <p>{translator.decode("car.sold")}</p> </div> : null
                        }
                        {
                            singleCar.carInfo.Status.toLowerCase() == "reserved" ? <div className={`${styles.reserved}`}> <p>{translator.decode("car.reserved")}</p> </div> : null
                        }
                        <CarCardHeader IconSubSection={singleCar.iconSubSection.IconSubSection} id={singleCar.id} themeColor={themeColor} />
                        <CarSingleCarousel pictureObjects={carImg} themeColor={themeColor} />
                    </div>
                </HolderStyled>
                <HolderStyled bgColor={themeColor} className={`${styles.carEquipmentHolder}`}>
                    <div className={`${styles.carInfoPhone}`}>
                        <CarInfo Brand={singleCar.carInfo.Brand} Model={singleCar.carInfo.Model} Version={singleCar.carInfo.Version}
                        Energy={singleCar.carInfo.Energy} RegNb={singleCar.carInfo.RegNb} Gears={singleCar.carInfo.Gears} CirculationDate={singleCar.carInfo.CirculationDate}
                        Mileage={singleCar.carInfo.Mileage} Park={singleCar.carInfo.StoragePlace.City} Color={singleCar.carInfo.Color} Nb_Col={2} Nb_Elem={10} Car_Type={singleCar.carInfo.CarType.Name} themeColor={themeColor} Link={singleCar.carInfo.Link ?? ""} RepairCost={singleCar.carInfo.RepairCost} />
                    </div>
                    <div className={`${styles.carCostPhone}`}>
                        <CarCost carCost={singleCar.carInfo.SellPrice} themeColor={themeColor} rentalCost={0} CustomText={singleCar.carCost.CustomText} />
                    </div>
                    <div>
                        <h2 className={"titleEquipment"}>{translator.decode("categories.comments").toUpperCase()}</h2>
                        {
                            ["", undefined, null].includes(singleCar.carInfo.Comments) ?
                                <p className="fst-italic">{translator.decode("categories.noComments")}</p>
                                :
                                <p>{singleCar.carInfo.Comments}</p>
                        }
                    </div>
                </HolderStyled>
                {
                    carEquipment.length != 0 ?
                    <HolderStyled bgColor={themeColor} className={`${styles.carEquipmentHolder}`}>
                        <h2 className={"titleEquipment"}>{translator.decode("categories.equipments").toUpperCase()}</h2>
                        <CarEquipment Equipment={carEquipment} themeColor={themeColor}/>
                    </HolderStyled>
                    :null
                }
            </div>
{/*-------------------------- Box sticky avec CarInfo + Price + 2 btn------------------------------ */}
            <div className={`${styles.carElementContainerRight}`}>
                <HolderStyled bgColor={themeColor} className={`${styles.boxRight}`} >
                    <div className={`${styles.carElementInfoContainer} ${styles.resetPaddingTopBotCarInfo} col-12`}>
                        <CarInfo Brand={singleCar.carInfo.Brand} Model={singleCar.carInfo.Model} Version={singleCar.carInfo.Version}
                        Energy={singleCar.carInfo.Energy} RegNb={singleCar.carInfo.RegNb} Gears={singleCar.carInfo.Gears} CirculationDate={singleCar.carInfo.CirculationDate}
                        Mileage={singleCar.carInfo.Mileage} Park={singleCar.carInfo.StoragePlace.City} Color={singleCar.carInfo.Color} Nb_Col={2} Nb_Elem={10} Car_Type={singleCar.carInfo.CarType.Name} themeColor={themeColor} Link={singleCar.carInfo.Link ?? ""} RepairCost={singleCar.carInfo.RepairCost}/>
                    </div>
                    <HrStyled bgColor={themeColor}/>
                    <div className={`${styles.separatingLineHolder}`}>
                        <div className={`${styles.ctaCarCost}`}>
                            <CarCost carCost={singleCar.carInfo.SellPrice} themeColor={themeColor} rentalCost={0} CustomText={singleCar.carCost.CustomText} />
                        </div>
                    </div>
                    <HrStyled bgColor={themeColor}/>
                    <div className={`${styles.posbtnAlt}`}>
                        {
                            isConnected && singleCar.carInfo.Status.toLowerCase() !== "sold" ? <ButtonAlt bgColor={themeColor} minWidth={"35%"} onClick={()=> setModalReservation(true)}>{translator.decode("carElem.reservation")}<span style={{ color: "red" }}>*</span></ButtonAlt>
                            : null
                        }
                        <Link to={infoRequest} className={`${styles.link}`}>
                            <ButtonAlt bgColor={themeColor} >
                                {translator.decode("dynamic.callback")}
                            </ButtonAlt>
                        </Link>
                    </div>
                    {
                        isConnected && singleCar.carInfo.Status.toLowerCase() !== "sold" ?
                            <div className={`${styles.disponibilitySection}`}>
                                <p><span>*</span>{translator.decode("car.disclaimer")}</p>
                            </div>
                        : null
                    }
                    <ModalMakeReservation show={modalReservation} onClose={handleToggleReservationModal} closeModal={handleToggleReservationModal} makeReservation={handleMakeReservation} themeColor={themeColor}/>
                    <ModalCta show={modalCta} onClose={handleToggleCtaModal} closeModal={handleToggleCtaModal} themeColor={themeColor}/>
                    <ModalConfirmation show={modalConfirm} onClose={handleToggleModalConfirm} closeModal={handleToggleModalConfirm} themeColor={themeColor} isOkay={isOkay} />
                </HolderStyled>
            </div>
{/*-------------------------- Box sticky avec CarInfo + Price + 2 btn------------------------------ */}
        </div>
    );
}

export default CarElement;
